<template>
<div class="buttonGroup-ui" :class="{'fixed':datas.isFixed}" :style="btStyle">
    <div class="button" v-for="(item,i) in datas.items" :key="i" @click="clickButton(item)" :style="style" v-if="i<showNum">
        <img class="icon" :src="item.icon" v-if="item.icon">
        <div class="name">
            {{item.btName}}
        </div>
    </div>
</div>
</template>

<script>
// 标题
import {
    openLocation
} from "@/utils/wxuser";
export default {
    name: "buttonGroup",
    props: {
        datas: Object
    },
    data() {
        return {
            showNum: 1
        };
    },
    methods: {
        clickButton(item) {
            if (item.btType == 'phone' && item.phoneNumber) {
                window.location.href = `tel://${item.phoneNumber}`
            }
            if (item.btType == 'map') {
                var obj = {};
                obj.latitude = item.lat;
                obj.longitude = item.lon;
                openLocation(obj);
            }
            if (item.btType == 'link' && item.link) {
                window.location.href = item.link
            }
        }
    },
    computed: {
        btStyle() {
            return `background:${this.datas.btColor};`
        },
        style() {
            var style = `color:${this.datas.fontColor};font-size:${this.datas.fontSize};font-weight: ${this.datas.isBold?'bold':'none'};`

            return style
        }
    },
    mounted() {
        if (this.datas.btStyle == 'diy') {
            this.showNum = this.datas.items.length
        }
    }
};
</script>

<style lang="less">
.buttonGroup-ui {

    display: flex;
    justify-content: center;
    align-items: center;
    background: #FFFFFF;
    box-shadow: 0px -3px 6px 0px rgba(0, 0, 0, 0.15);
    border-radius: 15px;
    margin: 0 0.4rem;
    width: calc(100% - 0.8rem);
    overflow: hidden;
    z-index: 10;

    &.fixed {
        margin: 0;
        border-radius: 15px 15px 0px 0px;
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
    }

    .button {
        flex: 1;
        padding: 0.426667rem 0;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #2964CF;
        font-size: 12px;
        line-height: 1.4;

        .icon {
            height: 14px;
            width: 14px;
            margin-right: 5px;
        }
    }

}
</style>



// WEBPACK FOOTER //
// src/components/polymerization/buttonGroup.vue